import { render } from "./TaskSettingsDescription.vue?vue&type=template&id=256ecf79"
import script from "./TaskSettingsDescription.vue?vue&type=script&lang=js"
export * from "./TaskSettingsDescription.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsDescription.vue?vue&type=style&index=0&id=256ecf79&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__